var pym = require("./lib/pym");
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var $ = require("./lib/qsa");
var { isMobile } = require("./lib/breakpoints");
var pymChild = null;
var { COLORS, classify, fmtComma } = require("./lib/helpers");
var dot = require("./lib/dot");
// var templateSource = require("./_grid.html");
// var gridTemplate = dot.compile($.one("#grid-template").innerHTML);

pym.then(child => {
    pymChild = child;

    shuffleGrid("grid", "grid-item-wrapper"); // shuffle grid onload
    document.getElementById("all").checked = true; // check show all checkbox onload

    child.sendHeight();

    // child.onMessage("on-screen", function(bucket) {
    //     ANALYTICS.trackEvent("on-screen", bucket);
    // });
    // child.onMessage("scroll-depth", function(data) {
    //     data = JSON.parse(data);
    //     ANALYTICS.trackEvent("scroll-depth", data.percent, data.seconds);
    // });

    window.addEventListener("resize", () => child.sendHeight());
});

// console.clear();

var data = window.DATA;
var controls = $.one(".controls");
var dropdown = document.getElementById("dropdown");
var gridContainer = $.one(".grid");
var gridItems = document.querySelectorAll(".grid-item-wrapper");
var radioItems = document.getElementById("radio");
var showAllCheck = document.getElementById("all");

var shuffleGrid = function(c, el) {
  var container = document.getElementById(c);
  var elements = Array.prototype.slice.call(container.getElementsByClassName(el));

  // console.log(Object.keys(data[0]));

  elements.forEach(function(element) {
    container.removeChild(element);
  });

  shuffleData(elements);

  elements.forEach(function(element) {
    container.appendChild(element);
  })
}

var shuffleData = function(array) {
  // shuffle data (from: https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array)
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

radioItems.onchange = function() {
  var categoryChecked = $(
    ".radio input[type=checkbox]:checked",
    radioItems
  ).map((el) => el.getAttribute("value"));

  var value = categoryChecked;
  console.log(value);
  clearClasses(gridItems);

  if (value != "") {
    gridItems.forEach(function(g) {
      if (value == "all") {
        clearClasses(gridItems);
      } else if (!value.some(r => g.classList.contains(r))) {
        showAllCheck.checked = false;
        g.classList.add("hide");
        g.classList.remove("show");
        pymChild.sendHeight();
      }
    })
  }

  if (pymChild) {
    pymChild.sendHeight();
  }
}

var clearClasses = function(data) {
  data.forEach(function(item) {
    if (item.classList.contains("hide")) {
      item.classList.remove("hide");
    }

    if (!item.classList.contains("show")) {
      item.classList.add("show");
    }
  })
}

var uncheckAll = function() {
  document.querySelectorAll('input[type="checkbox"]')
    .forEach(el => el.checked = false);
};

showAllCheck.addEventListener("change", e => {
  if (e.target.checked) {
    uncheckAll();
    showAllCheck.checked = true;
  }
});

// shuffle random link onclick
var surpriseBtn = document.getElementById("surprise");

var randomEl = function(items) {
  return items[Math.floor(Math.random() * items.length)];
}

surpriseBtn.onclick = function() {
  var link = document.getElementById("surprise-link");
  var url = "https://www.npr.org/";

  url += randomEl(data).seamus_id;
  console.log(url);

  link.setAttribute("href", url);
  // return true;
}
